export default __webpack_public_path__ + "static/media/fniris3.70d373d8.png";